import AjaxUtils from "../../util/ajax_utils";


export const ApckVulnBulkAssigneeForm = {
    props: {
        url: String,
        vuln_count: Number,
        assignee_options: {
            type: Array,
            default: () => []
        },
        selected_vulns: {
            type: Array,
            default: () => []
        },
    },
    data: function () {
        return {
            assignee: null,
            notes: null,
            loaded: true,
        };
    },
    methods: {
        save: function () {
            var cmp = this;

            cmp.$dialog.confirm(
                `You are about to apply this change to ${cmp.vuln_count} vulnerabilities, are you sure?`,
                'Apply bulk action',
                function () {
                    const data = {'assignee': cmp.assignee, 'notes': cmp.notes};
                    if (cmp.selected_vulns.length) {
                        data.selected_vulns = cmp.selected_vulns;
                    }
                    cmp.loaded = false;
                    AjaxUtils.ajax_post({
                        url: cmp.url,
                        data: JSON.stringify(data),
                        success: function (json, status, xhr) {
                            cmp.$emit('assignee-updated', json);
                            cmp.$emit('close');
                            cmp.loaded = true;
                        },
                        fail: function (json, status, xhr) {
                            cmp.$flash({
                                type: 'error',
                                message: json.message ? json.message : 'Failed to update vulnerabilities'
                            })
                            cmp.loaded = true;
                            cmp.$emit('close');
                        }
                    });
                }
            );
        },
    },
    template: `
        <div>
            <apck-field>
                <apck-select
                    v-model="assignee"
                    label='Assignee'
                    :options="assignee_options"
                />
              </apck-field>
            <apck-field>
                <apck-text
                    v-model="notes"
                    label="Notes"
                    :rows="5"
                />
            </apck-field>

            <apck-button title="Save" value="Save" icon="fa-save" class="btn-positive" :handler="save"/>
            <apck-mask :trigger="!loaded" :target="(mask) => mask.$parent.$parent.$refs.lightboxouter"/>
        </div>
    `
}

export const ApckVulnBulkPriorityForm = {
    props: {
        url: String,
        vuln_count: Number,
        selected_vulns: {
            type: Array,
            default: () => []
        },
    },
    data: function () {
        return {
            priority: null,
            priority_options: [
                {'label': '--- Unset ---', 'value': null},
                {'label': 'High', 'value': '4.0-high'},
                {'label': 'Medium', 'value': '3.0-medium'},
                {'label': 'Low', 'value': '2.0-low'}
            ],
            notes: null,
            loaded: true,
        };
    },
    methods: {
        save: function () {
            var cmp = this;

            cmp.$dialog.confirm(
                `You are about to apply this change to ${cmp.vuln_count} vulnerabilities, are you sure?`,
                'Apply bulk action',
                function () {
                    const data = {'priority': cmp.priority, 'notes': cmp.notes};
                    if (cmp.selected_vulns.length) {
                        data.selected_vulns = cmp.selected_vulns;
                    }
                    cmp.loaded = false;
                    AjaxUtils.ajax_post({
                        url: cmp.url,
                        data: JSON.stringify(data),
                        success: function (json, status, xhr) {
                            cmp.$emit('priority-updated', json);
                            cmp.$emit('close');
                            cmp.loaded = true;
                        },
                        fail: function (json, status, xhr) {
                            cmp.$flash({
                                type: 'error',
                                message: json.message ? json.message : 'Failed to update vulnerabilities'
                            })
                            cmp.loaded = true;
                            cmp.$emit('close');
                        }
                    });
                }
            );


        },
    },
    template: `
        <div>
            <apck-field>
                <apck-select
                    v-model="priority"
                    label='Priority'
                    :options="priority_options"
                />
              </apck-field>
            <apck-field>
                <apck-text
                    v-model="notes"
                    label="Notes"
                    :rows="5"
                />
            </apck-field>

            <apck-button title="Save" value="Save" icon="fa-save" class="btn-positive" :handler="save"/>
            <apck-mask :trigger="!loaded" :target="(mask) => mask.$parent.$parent.$refs.lightboxouter"/>
        </div>
    `
}

export const ApckVulnBulkStatusForm = {
    props: {
        url: String,
        vuln_count: Number,
        selected_vulns: {
            type: Array,
            default: () => []
        },
    },
    data: function () {
        return {
            status: null,
            status_options: [
                {'label': 'Unfixed', 'value': 'unfixed'},
                {'label': 'Fixed', 'value': 'fixed'},
                {'label': 'False Positive', 'value': 'false_positive'},
                {'label': 'Acceptable Risk', 'value': 'acceptable_risk'},
                {'label': 'Backported', 'value': 'backported'},
                {'label': 'Investigating', 'value': 'investigating'}
            ],
            suppression: null,
            suppression_options: [
                {'label': '14 Days', 'value': 14},
                {'label': '30 Days', 'value': 30},
                {'label': '60 Days', 'value': 60},
                {'label': '90 Days', 'value': 90},
                {'label': '6 Months', 'value': 180},
                {'label': '1 Year', 'value': 366},
                {'label': 'Forever', 'value': 99999},
            ],
            notes: null,
            loaded: true,
        };
    },
    computed: {
        suppression_eligible() {
            return ['false_positive', 'acceptable_risk'].indexOf(this.status) !== -1;
        },
        suppression_description() {
            return this.suppression_eligible ? '' : 'Suppression periods can only be applied to vulnerabilities marked as False Positive or Acceptable Risk.';
        }
    },
    watch: {
        status: {
            handler(newVal) {
                if (['false_positive', 'acceptable_risk'].indexOf(newVal) !== -1) {
                  if (this.suppression === null) this.suppression = 14;
                } else {
                  this.suppression = null;
                }
            },
        },
    },
    methods: {
        save: function () {
            var cmp = this;

            cmp.$dialog.confirm(
                `You are about to apply this change to ${cmp.vuln_count} vulnerabilities, are you sure?`,
                'Apply bulk action',
                function () {
                    const data = {'status': cmp.status, 'suppression': cmp.suppression, 'notes': cmp.notes};
                    if (cmp.selected_vulns.length) {
                        data.selected_vulns = cmp.selected_vulns;
                    }
                    cmp.loaded = false;
                    AjaxUtils.ajax_post({
                        url: cmp.url,
                        data: JSON.stringify(data),
                        success: function (json, status, xhr) {
                            cmp.$emit('status-updated', json);
                            cmp.$emit('close');
                            cmp.loaded = true;
                        },
                        fail: function (json, status, xhr) {
                            cmp.$flash({
                                type: 'error',
                                message: json.message ? json.message : 'Failed to update vulnerabilities'
                            })
                            cmp.loaded = true;
                        }
                    });
                }
            )
        },
    },
    template: `
        <div>
            <apck-field>
                <apck-select
                    v-model="status"
                    label='Status'
                    :options="status_options"
                />
            </apck-field>

            <apck-field>
                <apck-select
                    v-model="suppression"
                    label='Suppress vulnerabilities for'
                    :options="suppression_options"
                    :disabled="!suppression_eligible"
                />
                <p v-if="suppression_description" class="option-note">{{ suppression_description }}</p>
            </apck-field>

            <apck-field>
                <apck-text
                    v-model="notes"
                    label="Notes"
                    :rows="5"
                />
            </apck-field>

            <apck-button title="Save" value="Save" icon="fa-save" class="btn-positive" :handler="save"/>
            <apck-mask :trigger="!loaded" :target="(mask) => mask.$parent.$parent.$refs.lightboxouter"/>
        </div>
    `
}


export const ApckVulnBulkNotesForm = {
    props: {
        url: String,
        vuln_count: Number,
        selected_vulns: {
            type: Array,
            default: () => []
        },
    },
    data: function () {
        return {
            notes: null,
            loaded: true,
        };
    },
    methods: {
        save: function () {
            var cmp = this;

            cmp.$dialog.confirm(
                `You are about to apply this change to ${cmp.vuln_count} vulnerabilities, are you sure?`,
                'Apply bulk action',
                function () {
                    const data = {'notes': cmp.notes || ''};
                    if (cmp.selected_vulns.length) {
                        data.selected_vulns = cmp.selected_vulns;
                    }
                    cmp.loaded = false;
                    AjaxUtils.ajax_post({
                        url: cmp.url,
                        data: JSON.stringify(data),
                        success: function (json, status, xhr) {
                            cmp.$emit('notes-updated', json);
                            cmp.$emit('close');
                            cmp.loaded = true;
                        },
                        fail: function (json, status, xhr) {
                            cmp.$flash({
                                type: 'error',
                                message: json.message ? json.message : 'Failed to update vulnerabilities'
                            })
                            cmp.loaded = true;
                        }
                    });
                }
            )
        },
    },
    template: `
        <div>
            <apck-field>
                <apck-text
                    v-model="notes"
                    label="Notes"
                    :rows="5"
                />
              </apck-field>

            <apck-button title="Save" value="Save" icon="fa-save" class="btn-positive" :handler="save"/>
            <apck-mask :trigger="!loaded" :target="(mask) => mask.$parent.$parent.$refs.lightboxouter"/>
        </div>
    `
}
